import Pagination from './Pagination'
import { MinimumCreatorDetail } from './ConferencePromo'
import { MinimumExhibitorDetail } from './ExhibitorDetail'
import { MinimumSeriesDetail } from './SeriesDetail'
import { MinimumSessionDetail } from './SessionDetail'
import { MinimumDashboardCreatorDetail } from './CreatorDetail'

const ConferenceSiteSearch = `
  ${Pagination}
  ${MinimumSeriesDetail}
  ${MinimumCreatorDetail}
  ${MinimumSessionDetail}
  ${MinimumExhibitorDetail}
  fragment ConferenceSiteSearch on ConferenceSiteSearch {
    paginationData {
      ...Pagination
    }
    results {
      ...MinimumSeriesDetail
      ...MinimumCreatorDetail
      ...MinimumSessionDetail
      ...MinimumExhibitorDetail
    }
  }
`

export const DashboardConferenceSiteSearch = `
  ${MinimumDashboardCreatorDetail}
  ${ConferenceSiteSearch}
  fragment DashboardConferenceSiteSearch on ConferenceSiteSearch {
    ...ConferenceSiteSearch
    results {
      ...MinimumDashboardCreatorDetail
    }
  }
`

export default ConferenceSiteSearch
